import api from '../api';
import type {
  CampaignLogsResponse,
  CampaignLogsFilters,
  AccountOption,
  CampaignOption,
  CampaignDetail,
} from '../../types/adminStatistics';

/**
 * Get campaign logs with filters
 */
export const getCampaignLogs = async (
  filters: CampaignLogsFilters
): Promise<CampaignLogsResponse> => {
  const response = await api.get('/api/admin/campaign-statistics/logs', {
    params: filters,
  });
  return response.data;
};

/**
 * Get list of accounts for filter dropdown
 */
export const getAccounts = async (search?: string): Promise<AccountOption[]> => {
  const response = await api.get('/api/admin/campaign-statistics/accounts', {
    params: { search },
  });
  return response.data.accounts;
};

/**
 * Get list of campaigns for an account
 */
export const getCampaigns = async (accountId: number): Promise<CampaignOption[]> => {
  const response = await api.get('/api/admin/campaign-statistics/campaigns', {
    params: { account_id: accountId },
  });
  return response.data.campaigns;
};

/**
 * Get full campaign detail (filters, pages, AB test)
 */
export const getCampaignDetail = async (campaignId: number): Promise<CampaignDetail> => {
  const response = await api.get('/api/admin/campaign-statistics/campaign-detail', {
    params: { campaign_id: campaignId },
  });
  return response.data.campaign;
};

/**
 * Export campaign logs to CSV
 */
export const exportCampaignLogs = async (filters: Omit<CampaignLogsFilters, 'page' | 'per_page'>): Promise<void> => {
  const response = await api.get('/api/admin/campaign-statistics/export', {
    params: filters,
    responseType: 'blob',
  });

  // Create download link
  const blob = new Blob([response.data], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `campaign-logs-${filters.start_date}-to-${filters.end_date}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
